export const phoneRegExp = /^[0-9]{10}?[0-9]{0,5}/;

export const dateRegExp =
  /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

export const zipCodeRegExp = /^\d{5}-?(?:\d{4})?$/;

export const postalCodeRegExp =
  /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/;

export const ssnRegExp =
  /^(?!219-09-9999|078-05-1120)(?!666|000|9\d{2})(N{3}-?N{2}-?|\d{3}-?(?!00)\d{2}-?)(?!0{4})\d{4}$/;

export const authNamePrefix = /^~\/[a-zA-Z]+\//;

export const emailRegExp =
  /^(^(?!^\.)[\w\.\-\+]+)@([\w\-\.]+)((\.(\w){2,})+)$/i;

export const addressRegExp = /^[a-zA-Z0-9]+[a-zA-Z0-9 ,.'&`#-]*$/g;

export const textRegExp = /^[a-zA-Z]+[a-zA-Z0-9 ,.'&`-]*$/g;
